module.exports = __webpack_public_path__ + "static/img/464_phase_function_Paper_PointsHejduk_Prediction.8f75fd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/464_phase_function_Paper_PointsHejduk_Prediction.png
// module id = gpu0
// module chunks = 0